import React, {useEffect, useState} from "react";
import {useParams} from "react-router";
import Loader from "../../Components/Loader";
import Sidebar from "../../Components/Main/Sidebar/Sidebar";
import api from '../../../util/api'
import styled from "styled-components";
import Room from "../../Components/OpenTok/Room";

const StartSessionModal = styled.div`
    width: 300px;
    background: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 25px;
    text-align: center;
    z-index: 9999;
`

const StartButton = styled.button`
    background: #5562C0;
    text-align: center;
    height: 55px;
    color: white;
    border: 0;
    border-radius: 0px;
    cursor: pointer;
    display: block;
    font-size: 16px;
    text-transform: uppercase;
    text-decoration: none;
    display: block;
    width: 45%;
`;

const ChangeLayout = styled.div`
position: absolute;
    right: 0;
    top: 0;
    color: white;
    z-index: 99;
`;

const StartButtonLink = styled.a`
    background: #5562c0;
    text-align: center;
    height: 55px;
    color: white;
    border: 0;
    border-radius: 0px;
    cursor: pointer;
    display: block;
    font-size: 16px;
    text-transform: uppercase;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45%;
`

const ButtonContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
`


export default ({isInstructor}) => {
    let {id} = useParams();
    const [lesson, setLesson] = useState(null);
    const [recordAllSessions, setRecordAllSessions] = useState(false);

    useEffect(() => {
        if (id) {
            api().get(`/session/${id}/start`).then(response => setLesson(response.data.data))
        }
    }, [id])

    useEffect(() => {
        if(lesson){
            setRecordAllSessions(!!lesson.record_all_sessions)
        }
    }, [lesson]);


    if (lesson) {

        return (
            <>
                <Sidebar
                    lesson={lesson}
                    recordAllSessions={recordAllSessions}
                    isInstructor={isInstructor}
                    lesson_id={id}
                    in_lesson={true}
                />
                <Room
                    autojoin={!!lesson.private}
                    apiKey={'46914104'}
                    sessionUuid={lesson.uuid}
                    openTokId={lesson.video_session_id}
                    token={lesson.token}
                    isInstructor={isInstructor}
                />
            </>
        );
    }

    return <Loader/>;
};
